import { getApplicationSettings } from 'owa-application-settings';
import { useState } from 'owa-react';
import { useWindowEvent } from 'owa-react-hooks/lib/useWindowEvent';

export default function useIsSearchWindowInactive(): boolean {
    const isMonarch = getApplicationSettings('PlatformType').isMonarch;
    const [isWindowFocused, setIsWindowFocused] = useState(() => document.hasFocus());

    useWindowEvent(
        'focus',
        () => setIsWindowFocused(true),
        'SearchWindowFocus',
        [isMonarch],
        undefined,
        !isMonarch
    );
    useWindowEvent(
        'blur',
        () => setIsWindowFocused(document.hasFocus()),
        'SearchWindowFocus',
        [isMonarch],
        undefined,
        !isMonarch
    );

    return isMonarch && !isWindowFocused;
}
